//Built-in libraries
import { useState } from 'react';

//Custom components
import Table from 'components/UI/Table';
import Card from 'components/UI/Card';

//Services

//Assets and Miscellaneous

interface DistrictBreakdownDeniedProps {
  data: Array<{
    name: string;
    projects: number;
  }>;
}
const DistrictBreakdownDeniedWidget = ({
  data,
}: DistrictBreakdownDeniedProps) => {
  const [perPage, setPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalPage, setTotalPage] = useState<number>(1);

  const nextPageHandler = () => {
    setPage((prevState) => (prevState === totalPage ? totalPage : page + 1));
  };

  const previousPageHandler = () => {
    setPage((prevState) => (prevState > 1 ? page - 1 : 1));
  };

  const tableColumns = [
    {
      id: 'name',
      Header: 'District',
      accessor: 'name',
      Cell: (row: any) => {
        return row.value;
      },
    },
    {
      id: 'projects',
      Header: () => <div>Projects</div>,
      accessor: 'projects',
      Cell: (row: any) => (
        <div>
          <span>{row.value}</span>
        </div>
      ),
    },
  ];

  const tablePagination = {
    page: page,
    pageSize: perPage,
    pageCount: totalPage,
    currentPage: page,
    setPageSize: (v: number) => setPerPage(v),
    nextPage: nextPageHandler,
    previousPage: previousPageHandler,
  };

  return (
    <>
      <Card title='District Breakdown - Denied'>
        {data && (
          <div className='h-full w-full'>
            <div className='h-96 border rounded-b-md w-full'>
              <Table
                cols={tableColumns}
                tableData={data}
                pagination={tablePagination}
                height='h-5/6'
              />
            </div>
          </div>
        )}
      </Card>
    </>
  );
};

export default DistrictBreakdownDeniedWidget;
